export const getAvatarLabel = (name: string): string => {
  if (!name?.trim()) {
    return '';
  }

  // Remove special characters, keep only letters and numbers
  const cleanName = name.replace(/[^a-zA-Z0-9\s]/g, '').trim();

  if (!cleanName) {
    return '';
  }

  const splitName = cleanName.split(/\s+/); // Split by any whitespace

  if (splitName.length === 1) {
    return cleanName.toUpperCase().slice(0, 3);
  }

  return splitName
    .map((word) => word.charAt(0))
    .filter((char) => char) // Remove empty strings from map result
    .join('')
    .toUpperCase()
    .slice(0, 3);
};
